import sortedFleetExecutionTasks from './sortedFleetExecutionTasks'

export interface TaskNode {
  fleet_execution_task_id: string
  primary_task: boolean
  machine_name: string
  status?: string
  start_date?: string
  machine_input?: any
  [key: string]: any
}

export interface TaskGroup {
  parent: TaskNode | null
  children: TaskNode[]
}

const hasActiveOrder = (filters: any): boolean =>
  !!(filters && filters.order && Object.values(filters.order).some(Boolean))

const orderChildren = (children: TaskNode[], filters: any): TaskNode[] =>
  hasActiveOrder(filters)
    ? sortedFleetExecutionTasks(children, filters)
    : children.slice().sort((a, b) => String(a.start_date || '').localeCompare(String(b.start_date || '')))

const buildTaskTree = (tasks: any[], filters?: any): TaskGroup => {
  if (!tasks || tasks.length === 0) return { parent: null, children: [] }

  const primaries = tasks.filter((t) => t.primary_task)
  const parent = primaries.length === 1 ? primaries[0] : null
  const children = orderChildren(tasks.filter((t) => t !== parent), filters)
  return { parent, children }
}

export default buildTaskTree
